import { createFileRoute } from "@tanstack/react-router";

import MarketingHead from "@/components/marketing/article/MarketingHead";
import { CONTENT_CACHE_CONTROL } from "@/content/cachePolicy";
import { CANONICAL_ORIGIN } from "@/content/types";

/**
 * `/search`, deliberately nothing but a head.
 *
 * The published page is a Webflow template that renders an empty
 * `<div><div></div></div>` and no more: its search field was removed from the
 * site and the route was left answering 200 with `noindex`, no inbound links
 * and no results markup. Reproducing that is the whole of the parity here:
 * building a search feature would ship a page the published site does not have.
 *
 * It is off `prerenderPages.ts` on purpose, which also keeps it out of the
 * sitemap: a `noindex` page has no business in one, and rendering an empty body
 * per request costs nothing.
 */
const HEAD = {
  title: "Search Results | Webshare",
  description:
    "Search results for Webshare Proxy. 24/7 monitoring. Enterprise grade " +
    "support. Fast & friendly support team. Run your internet business on " +
    "Webshare.",
  canonical: `${CANONICAL_ORIGIN}/search`,
};

export const Route = createFileRoute("/search")({
  headers: () => ({ "Cache-Control": CONTENT_CACHE_CONTROL }),
  component: SearchResults,
});

function SearchResults() {
  return (
    <>
      <MarketingHead {...HEAD} />
      <meta name="robots" content="noindex" />
    </>
  );
}
